/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module CportalModule */

import {
    Component,
    Input,
} from '@angular/core';

import { IProxyConfiguration } from 'generated-types';
import { L10nService } from '@vmw/ngx-vip';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { ProxyConfiguration } from 'object-types';
import * as l10n from './split-proxy-configuration.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *      Component used to represent System proxy.
 * @author Ratan Kumar
 */

@Component({
    selector: 'split-proxy-configuration',
    templateUrl: 'split-proxy-configuration.component.html',
})

export class SplitProxyConfigurationComponent {
    /**
     * SplitProxyConfiguration MessageItem.
     */
    @Input()
    public editable: MessageItem<IProxyConfiguration>;

    /**
     * Proxy Config object type.
     */
    public objectType = ProxyConfiguration;

    /**
     * Get keys from source bundles for template usage.
     */
    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
